import PageMeta from "../../../../shared/ui/common/PageMeta";
import AuthLayout from "./AuthPageLayout";
import ResetPasswordForm from "../components/ResetPasswordForm";

export default function ResetPassword() {
  return (
    <>
      <PageMeta />
      <AuthLayout hideLanguageSelector={false}>
        <ResetPasswordForm />
      </AuthLayout>
    </>
  );
}
